(() => {
  const handleBuyNow = async (event) => {
    const button = event.target.closest('[data-tanatel-buy-now]');
    if (!button || button.disabled) return;

    const form = button.closest('form');

    event.preventDefault();
    event.stopPropagation();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const formData = form ? new FormData(form) : new FormData();
      if (!formData.has('id') && button.dataset.variantId) {
        formData.append('id', button.dataset.variantId);
        formData.append('quantity', '1');
      }

      const addUrl = window.EnfitahSettings?.routes?.cart_add_url || '/cart/add.js';
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!response.ok) throw new Error('Unable to add product for checkout');

      window.location.assign(button.dataset.checkoutUrl || '/checkout');
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      console.error('[Tanatel] Buy now failed', error);
    }
  };

  document.addEventListener('click', handleBuyNow, true);
})();
